<mat-dialog-content>
  <iframe
    src="https://app.termly.io/document/cookie-policy/5ba3eff8-6dae-49bf-86b3-e2baca7823b1"
    frameborder="0"></iframe>
  <div fxLayout="column" fxLayoutAlign="center center">
    <button mat-raised-button (click)="cancel()">CLOSE</button>
  </div>
</mat-dialog-content>
